<template>
  <form>
    <section v-if="diligence" class="section pt-0 pb-0">
      <div v-if="diligence.description" class="content">
        <p><strong>Orientações do pregoeiro:</strong> {{ diligence.description }}</p>
      </div>
    </section>

    <DetailItem :item="item" :qualification-company="company" :situation="situation" />

    <DocumentsWrapper
      :item="item"
      :qualificationCompany="company"
      :situation="situation"
      :judgmentDiligence="diligence"
    />
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

import DetailItem from '@/views/Pregao/AuctionContainer/Documents/DetailItem';
import DocumentsWrapper from '@/views/Pregao/AuctionContainer/Documents/DocumentsWrapper';

export default {
  name: 'JudgmentDiligenceUpload',
  components: {
    DetailItem,
    DocumentsWrapper,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    diligence: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      auction: 'obterOfertaCompra',
    }),
    situation() {
      return this.auction.situacao.id;
    },
  },
};
</script>
